import { customElement } from 'lit/decorators.js';
import { OutlineElement } from 'src/components/base/outline-element/outline-element';
import componentStyles from './idb-loading.css.lit';
import { TemplateResult, html } from 'lit';

@customElement('idb-loading')
export class IdbLoading extends OutlineElement {
  static styles = [componentStyles];

  render(): TemplateResult {
    return html`
    <div class="content-loading loading-results-remote-content">
      <div class="content-loading__bars">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
      </div>
      <h5 class="text-center"> <slot></slot></h5>
    </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'idb-loading': IdbLoading;
  }
}
